<template>
  <modal-dialog
    :show="show"
    @close="$emit('close')"
    target-class="modal__card--medium"
  >
    <div class="card-promotions">
      <div class="card-promotions__header">
        <h3 class="header-3" style="display: flex; align-items: center; gap: 8px;">
          <span>🔥</span> {{ $t("mylist.deals.modal.title") }}
        </h3>
      </div>

      <div class="card-promotions__content">
        <div 
          v-for="(promo, index) in promotions" 
          :key="promo.id"
          class="promo-item"
        >
          <!-- Títol de la promo -->
          <h4 class="promo-item__title">{{ promo.title }}</h4>
          
          <!-- Descripció -->
          <p class="promo-item__description">{{ promo.description }}</p>
          
          <!-- Codi de cupó (si n'hi ha) -->
          <div v-if="promo.couponType === 'code'" class="promo-item__code-section">
            <div 
              class="promo-item__code"
              @click="copyCode(promo.couponCode, promo.id)"
              :class="{ 'promo-item__code--copied': copiedPromoId === promo.id }"
            >
              {{ copiedPromoId === promo.id ? '✓ ' + $t("mylist.deals.modal.copiedCode") : $t("mylist.deals.modal.copyCode") + ' ' + promo.couponCode }}
            </div>
            
            <a 
              v-if="promo.linkUrl"
              :href="addUtm(promo.linkUrl)" 
              :target="target()"
              @click.stop=""
              class="promo-item__info-link"
            >
              <span>{{ $t("mylist.deals.modal.goToPromotion") }}</span> →
            </a>
          </div>
          
          <!-- Si no hi ha codi però sí link d'info -->
          <a 
            v-else-if="promo.linkUrl"
            :href="addUtm(promo.linkUrl)" 
            :target="target()"
            @click.stop=""
            class="promo-item__info-link"
          >
            <span>{{ $t("mylist.deals.modal.goToPromotion") }}</span> →
          </a>
          
          <!-- Separador entre promos (no en l'última) -->
          <div 
            v-if="index < promotions.length - 1" 
            class="promo-item__separator"
          ></div>
        </div>
      </div>
      
      <!-- Botó principal -->
      <a 
        :href="addUtm(productUrl)" 
        :target="target()"
        @click.stop=""
        class="button button--primary button--block promo-cta-final"
      >
        {{ $t("mylist.deals.modal.visitStore") }}
      </a>
    </div>
  </modal-dialog>
</template>

<script>
import ModalDialog from "../ui/ModalDialog";
import { mapGetters } from 'vuex';

export default {
  name: 'PromotionsModal',
  components: {
    ModalDialog,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    promotions: {
      type: Array,
      default: () => [],
    },
    productUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      copiedPromoId: null,
    };
  },
  computed: {
    ...mapGetters({
      isApp: 'isApp',
    }),
  },
  methods: {
    async copyCode(code, promoId) {
      try {
        await navigator.clipboard.writeText(code);
        this.copiedPromoId = promoId;
        
        setTimeout(() => {
          this.copiedPromoId = null;
        }, 2000);
      } catch (err) {
        console.error('Error copiant codi:', err);
        this.fallbackCopyCode(code, promoId);
      }
    },
    
    fallbackCopyCode(code, promoId) {
      const textArea = document.createElement('textarea');
      textArea.value = code;
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.select();
      
      try {
        document.execCommand('copy');
        this.copiedPromoId = promoId;
        setTimeout(() => {
          this.copiedPromoId = null;
        }, 2000);
      } catch (err) {
        console.error('Fallback copy failed:', err);
      }
      
      document.body.removeChild(textArea);
    },

    addUtm(url) {
      try {
        const u = new URL(url)
        u.searchParams.set('utm_source', 'hellowish')
        return u.toString()
      } catch {
        return url
      }
    },

    target() {
      if (this.isApp) {
        return "_self";
      }
      return "_blank";
    },

  },
};
</script>

<style scoped>
/* Modal de promocions */
.card-promotions__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f3f4f6;
}

.card-promotions__header h3 {
  margin: 0;
  font-size: 20px;
}

.card-promotions__content {
  max-height: 60vh;
  overflow-y: auto;
  position: relative;
}

.card-promotions__content::after {
  content: "";
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: linear-gradient(to bottom, transparent, white);
  pointer-events: none;
  display: block;
}

.promo-item {
  position: relative;
}

.promo-item__title {
  margin: 0 0 12px 0;
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  line-height: 1.5;
}

.promo-item__description {
  color: #4b5563;
  margin: 0 0 16px 0;
  font-size: 15px;
  line-height: 1.5;
}

.promo-item__code-section {
  margin-bottom: 16px;
}

.promo-item__code {
  background: #f9fafb;
  border: 2px dashed #d1d5db;
  padding: 12px 16px;
  border-radius: 8px;
  font-family: 'Courier New', monospace;
  font-weight: 700;
  font-size: 16px;
  color: #111827;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s;
  margin-bottom: 8px;
  user-select: none;
}

.promo-item__code:hover {
  background: #f3f4f6;
  border-color: #9ca3af;
}

.promo-item__code:active {
  transform: scale(0.98);
}

.promo-item__code--copied {
  background: #d1fae5;
  border-color: #10b981;
  color: #065f46;
}

.promo-item__info-link {
  display: inline-block;
  color: #5d50c6;
  font-size: 14px;
  text-decoration: none;
  margin-bottom: 16px;
  transition: color 0.2s;
}

.promo-item__info-link span {
  text-decoration: underline;
}

.promo-item__info-link:hover {
  color: #111827;
}

.promo-item__info-link:hover span {
  text-decoration: underline;
}

.promo-item__separator {
  height: 1px;
  background: #f3f4f6;
  margin-bottom: 24px;
}

.promo-cta-final {
  margin-top: 24px;
  position: sticky;
  bottom: 0;
}
</style>
